import { RadioField, RadioInput } from '@flos/react-ui';
import type { AttributeChangeProps } from '../../../types';
import { useState } from 'react';
import { useHippoText } from '../../../../../hooks/useHippoText';
import type { InsurancePeriod } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { opcInfoAtom } from '../../../../../recoil/atoms/opcInfoAtom';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

const InsurancePeriodChange = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const { attributeValue } = useRecoilValue(opcInfoAtom);
    const getHippoText = useHippoText();
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.cho
        ?.insurancePeriod;
    const [period, setPeriod] = useState<string>(currentOPCAttribute ?? attributeValue ?? '');

    const hippoText = {
        fiveYearsOption: getHippoText('DSS-COVERAGE-PACKAGE-PAGE-YEAR', { period: '5' }),
        tenYearsOption: getHippoText('DSS-COVERAGE-PACKAGE-PAGE-YEAR', { period: '10' })
    };

    const handleInsurancePeriodChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const { value } = event.target;
        updateCoverableAttribute({
            insurancePeriod: value as InsurancePeriod
        });
        setPeriod(value as InsurancePeriod);
        setIsOpcDataFilled(value !== attributeValue);
    };

    return (
        <div>
            <RadioField value={period} onChange={handleInsurancePeriodChange}>
                <RadioInput value="5year" label={hippoText.fiveYearsOption} />
                <RadioInput value="10year" label={hippoText.tenYearsOption} />
            </RadioField>
        </div>
    );
};

export default InsurancePeriodChange;
